import React, { useState, useEffect } from "react";
import { CheckCircle2, AlertCircle, Info, AlertTriangle, X } from "lucide-react";

export const Toast = ({ id, type = "info", message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(id);
    }, 4000);
    return () => clearTimeout(timer);
  }, [id, onClose]);

  const icons = {
    success: <CheckCircle2 size={18} style={{ color: "#059669" }} />,
    error: <AlertCircle size={18} style={{ color: "#dc2626" }} />,
    warning: <AlertTriangle size={18} style={{ color: "#d97706" }} />,
    info: <Info size={18} style={{ color: "#0284c7" }} />
  };

  const bgColors = {
    success: "#d1fae5",
    error: "#fee2e2",
    warning: "#fef3c7",
    info: "#e0f2fe"
  };

  const borders = {
    success: "#6ee7b7",
    error: "#fca5a5",
    warning: "#fcd34d",
    info: "#7dd3fc"
  };

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "12px 16px",
      backgroundColor: bgColors[type] || bgColors.info,
      border: `1px solid ${borders[type] || borders.info}`,
      borderRadius: "var(--radius-md)",
      boxShadow: "var(--shadow-md)",
      color: "var(--text-main)",
      fontSize: "0.88rem",
      fontWeight: "500",
      minWidth: "280px",
      maxWidth: "420px",
      animation: "toastSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards"
    }}>
      {icons[type]}
      <span style={{ flex: 1 }}>{message}</span>
      <button
        onClick={() => onClose(id)}
        style={{
          color: "var(--text-muted)",
          cursor: "pointer",
          padding: "2px",
          borderRadius: "4px"
        }}
      >
        <X size={14} />
      </button>
    </div>
  );
};
